/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsV1EodPriceState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_V1_EOD_PRICE_STATE_ENTITY_NAME = 'ixc.assets.v1.EodPrice';
export const ixcAssetsV1EodPriceStateEntity = new schema.Entity<IxcAssetsV1EodPriceState>(IXC_ASSETS_V1_EOD_PRICE_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcAssetsV1EodPriceState) => `${entity.assetId}-${entity.date}` });

